var scope_0 = require('/root/sh_website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/root/sh_website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b653eba538a8875ca5b38cb2915eacb7.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    